import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import EntityPropsUpdater from 'component/EntityPropsUpdater';
import Modal from 'components/Modal';
import FormInput from 'components/forms/FormInput';
import { Button } from 'react-bootstrap';
import Axios from 'axios';
import {formStatusDispatchHelper} from "actions/FormStatusActions";
import {addNotification} from "actions/NotificationsActions";

class CompanyDataForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      company: '',
      companyName: '',
    };
    this.defaultFieldTree = ['profile'];
  }

  toggleModal = show => {
    show = show === undefined ? false : show;
    this.setState({ showModal: show, company: '', companyName: '' });
  };

  updateCompanyName = () => {
    const { entity, changeEntity } = this.props;
    const { company, companyName } = this.state;
    Axios({
      url: '/api/clients/' + entity?.getUsername() + '/companydata.json',
      data: { company, companyName },
      method: 'PUT',

    })
      .then(response => {
        let resData = response.data;

        const newEntity = {
          ...entity
            .updateValue('company', resData.company, ['profile'])
            .updateValue('companyName', resData.companyName, ['profile'])
            .updateValue('debtorNumber', resData.debtorNumber, ['ident']),
        };

        changeEntity(newEntity, null, false);
        this.toggleModal(false);
        this.props.doNotify(1, messages.company_data_success);
      })
      .catch(error => {
        if (Axios.isCancel(error)) {
        } else {
          this.props.doNotify(3, messages.company_data_error, error);
        }
      });
  };

  render() {
    const {
      intl: { messages },
      entity,
      entityLoaded,
    } = this.props;

    const profile = entity?.getProfile();

    let company = this.state.company === '' ? profile?.getCompany() : this.state.company;
    let companyName = this.state.companyName === '' ? profile?.getCompanyName() : this.state.companyName;

    const iconEditClass = entityLoaded ? 'fa-save' : 'fa-spinner-third fa-spin';

    return (
      <div
        style={{
          width: 'fit-content',
          float: 'left',
          paddingRight: '10px',
        }}
      >
        <Modal show={this.state.showModal} onHide={this.toggleModal} bsSize="sm">
          <Modal.Header closeButton></Modal.Header>
          <Modal.Body>
            <div className="form-group-default">
              <FormInput
                label={messages.company}
                name="company"
                value={company}
                onChange={(name, value) => {
                  this.setState({ company: value });
                }}
              />
              <FormInput
                label={messages.company_name}
                name="companyName"
                value={companyName}
                onChange={(name, value) => {
                  this.setState({ companyName: value });
                }}
              />
              <Button
                bsSize="sm"
                class="btn btn-lg btn-default"
                style={{ float: 'right' }}
                onClick={this.updateCompanyName}
              >
                <i className="fa-fw fal fa-save" />
                {'Speichern'}
              </Button>
            </div>
          </Modal.Body>
        </Modal>
        <Button
          bsStyle="primary"
          className="btn-rounded"
          onClick={() => {
            this.toggleModal(true);
          }}
          disabled={!entityLoaded}
        >
          <i className={'fal m-r-10 sm-m-r-0 ' + iconEditClass} />{' '}
          <span className="hidden-xs">{messages.update_company_data}</span>
        </Button>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {};
};
const mapDispatchToProps = dispatch => {
  return {
    doNotify: (code, text) => {
      dispatch(addNotification(code, text));
    },
  };
};

export default injectIntl(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(CompanyDataForm)
);
